module.exports = __webpack_public_path__ + "duo@2x.5894712bcc4064bb4686902feed7633d.png";